import { createContext,useContext } from "react";


export const GlobalContext = createContext({})

export default function useGlobal() {
  return useContext(GlobalContext)
} 